export const queryKey = {
  coronaInfo: "corona-info",
}
